export default function autoHeight(event) {
  event.target.style.cssText = 'height:auto; padding:0'
  event.target.style.cssText = `height:${event.target.scrollHeight}px`
}
